<template>
  <div class="container">
    <div class="row mt-4">
      <div class="col-md-3 col-0 col-xl-4" />
      <div v-if="user != null" class="col-md-6 col-12 col-xl-4">
        <h3>Welcome {{ user.First_Name }}!</h3>
        <h6>Please create a new password for your account.</h6>
        <h6 v-if="errorMessage != ''" class="text-danger">
          {{ errorMessage }}
        </h6>
        <form v-if="!alreadyUpdated" @submit.prevent="updatePassword">
          <div class="form-group">
            <input
              type="text"
              style="display: none;"
              id="username"
              v-model="user.Email"
              autocomplete="username"
            />
            <label for="password">Password</label>
            <input
              type="password"
              class="form-control"
              id="newPassword"
              autocomplete="new-password"
              placeholder="At least 8 characters long"
              v-model="newPassword"
            />
          </div>
          <div class="form-group">
            <label for="password">Confirm Password</label>
            <input
              type="password"
              class="form-control"
              id="confirmPassword"
              autocomplete="new-password"
              placeholder="Confirm Password"
              v-model="confirmNewPassword"
            />
          </div>
          <button type="submit" class="btn btn-primary">Create Password</button>
        </form>
        <div v-if="alreadyUpdated">
          <router-link to="/signin" class="btn btn-primary mr-4"
            >Forgot Password</router-link
          >
          <router-link to="/signin" class="btn btn-primary ml-4"
            >Sign In</router-link
          >
        </div>
      </div>
      <div v-if="user == null" class="col-md-6 col-12 col-xl-4">
        Sorry there has been a problem. Please try again or contact support if
        the problem persists.
      </div>
      <div class="col-md-3 col-0 col-xl-4" />
    </div>
  </div>
</template>

<script>
import { nittyGritty } from "@/constants/NittyGritty.js";
import { Auth } from "aws-amplify";
import AWS from "aws-sdk";

export default {
  name: "Template",
  data() {
    return {
      user: "",
      newPassword: "",
      confirmNewPassword: "",
      errorMessage: "",
      newUserPassword: nittyGritty.newUserPassword,
      alreadyUpdated: false
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$store.commit("updateLoading", true);
      view.$data.user = await view.loadUser(view.$route.params.id);
      await Auth.signIn(view.$data.user.Email, view.$data.newUserPassword);
    } catch (e) {
      if (e.message === "Incorrect username or password.") {
        view.$data.errorMessage =
          "Your password has already been updated. Please sign in or request a password change.";
        view.$data.alreadyUpdated = true;
      } else {
        console.log(e);
      }
    }
    view.$store.commit("updateLoading", false);
  },
  methods: {
    async loadUser(userId) {
      var view = this;
      var res = await view.$store.getters.fetcher({
        query:
          `{
          user(id: ` +
          userId +
          `) 
          {
            User_Id
            First_Name
            Last_Name
            Email
            Phone
            Account_Id
            Organization_Id
            Cognito_Id
            Last_Login
          }
        }`
      });
      return res.data.user;
    },
    updatePassword() {
      var view = this;
      view.$data.errorMessage = "";
      if (view.checkThatEverythingLooksGood()) {
        Auth.currentAuthenticatedUser()
          .then(user => {
            return Auth.changePassword(
              user,
              view.$data.newUserPassword,
              view.$data.newPassword
            );
          })
          .then(data => {
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(
              view.$store.getters.awsCreds
            );
            AWS.config.region = "us-east-1";
            AWS.config.credentials.refresh(() => {
              var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
              var verifyParams = {
                UserAttributes: [
                  {
                    Name: "email_verified",
                    Value: "true"
                  }
                ],
                UserPoolId: "us-east-1_4e2RE8rbR",
                Username: view.$data.user.Email
              };
              cognitoidentityserviceprovider.adminUpdateUserAttributes(
                verifyParams,
                function(err, data) {
                  if (err) {
                    console.log("Admin verify email error: " + err, err.stack);
                    // an error occurred
                    view.$store.commit("updateLoading", false);
                  } else {
                    console.log("Admin verify email success: " + data); // successful response
                    view.$store.commit("updateLoading", false);
                  }
                }
              );
            });
            view.$store.commit("updateUser", view.$data.user);
            view.$router.replace({ name: "instructions" });
            return data;
          })
          .catch(e => {
            view.$data.errorMessage = e.errorMessage;
            console.log(e);
          });
      }
    },
    checkThatEverythingLooksGood() {
      var view = this;
      if (view.$data.newPassword.length < 8) {
        view.$data.errorMessage =
          "The password does not meet the minimum requirements: at least 8 characters long.";
        view.$data.newPassword = "";
        view.$data.confirmNewPassword = "";
        return false;
      }
      if (view.$data.newPassword != view.$data.confirmNewPassword) {
        view.$data.errorMessage =
          "The passwords don't match. Please try again.";
        view.$data.newPassword = "";
        view.$data.confirmNewPassword = "";
        return false;
      }

      return true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
